export class PipeFunctionModel {
    _id: string;
    id: number;
    name: string;
    code: string;

    constructor(_id = null,
        id = null,
        name = '',
        code = '') {
            this._id = _id;
            this.id = id;
            this.name = name;
            this.code = code;
    }
}
